import {IonContent, IonList} from '@ionic/react';
import React from 'react';
import {RouteComponentProps} from 'react-router';
import {actions, RootState} from '../store';
import StartList from "../domain/StartList";
import Contest from "../domain/Contest";

import "./StartListPage.css";
import ContestDetailTabHeader from "./components/ContestDetailTabHeader";
import {connect} from "react-redux";
import StartListItemComponent from "./components/StartListItem";
import StartListItem from "../domain/StartListItem";
import CalendarItems from "../domain/CalendarItems";
import {PluginListenerHandle, Plugins} from "@capacitor/core";

type StartListPageProps = RouteComponentProps<{ contestId: string, seriesId: string }> & typeof mapDispatchToProps & {
  contest?: Contest,
  lastUpdatedTimeStamp: Date,
  calendarItems: CalendarItems
};

type State = {
  searchValue?: string;
  showLoading: boolean;
}

class StartListPage extends React.Component<StartListPageProps, State> {
  private backButtonHandle ?: PluginListenerHandle;

  constructor(props: StartListPageProps) {
    super(props);
    if (!props.contest) {
      console.info("trigger contest reload");
      props.updateContest(props.match.params.contestId);
    }
    this.state = {
      searchValue: "",
      showLoading: false
    }
  }

  componentDidMount(): void {
    this.backButtonHandle = Plugins.App.addListener('backButton', () => this.props.history.push(`/contests/${this.props!.contest!.id}/series`));
  }

  componentWillUnmount(): void {
    this.backButtonHandle!.remove()
  }

  render() {
    const startList = this.props.contest ? this.props.contest.getStartList(this.props.match.params.seriesId).filterContent(this.state.searchValue) : undefined;
    console.info("render start list", startList, this.props.contest, this.props.match.params.seriesId);

    const tabHeaderProps = {
      searchBarEnabled: true,
      onSearchChanged: (value?: string) => this.setState({searchValue: value}),
      searchValue: this.state.searchValue
    };

    return (
      <>
        <ContestDetailTabHeader {...this.props}
                                {...tabHeaderProps}
                                onBack={() => this.props.history.goBack()}
                                canGoBack={!this.props.calendarItems.isEmpty()}/>
        {this.renderContent(startList)}
      </>
    );
  }

  renderContent(startList?: StartList) {
    if (startList) {
      return (
        <IonContent>
          <div className={"start-list-page-content"}>
            <IonList>
              {startList.map((i: StartListItem) => <StartListItemComponent key={i.id} {...this.props} item={i}/>)}
            </IonList>
          </div>
        </IonContent>
      )
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    calendarItems: state.calendar.thisWeeksCalendarItems,
    contest: state.contest.contest,
    lastUpdatedTimeStamp: state.contest.lastUpdatedTimeStamp,
  }
};

const mapDispatchToProps = {
  updateContest: (contestId: string) => actions.contest.updateContest(contestId),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  StartListPage
);
